import { ScommessaButton } from 'components/scommesseFiltersListScrollable/ScommesseFiltersListScrollable';
import { useMemo } from 'react';
import { SportsToolTipInfoScommessa } from 'types/swagger';

type ScommessaListScrollable = {
  label?: string;
  labelTrKey?: string;
  scommesseDescription?: Array<SportsToolTipInfoScommessa>;
};

function useScommessaListScrollable<T extends ScommessaListScrollable>(
  filteredGruppoList: Array<T>
): Array<ScommessaButton> {
  return useMemo(
    () =>
      (filteredGruppoList || []).map(({ label, labelTrKey, scommesseDescription }) => ({
        label: label || '',
        labelTrKey: labelTrKey || '',
        scommesseDescription,
      })),
    [filteredGruppoList]
  );
}

export default useScommessaListScrollable;
